var mapNestedKey = function mapNestedKey() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var key = arguments.length > 1 ? arguments[1] : undefined;
  return arr.reduce(function (acc, curr) {
    return acc.concat(curr);
  }, []).map(function (item) {
    return item == null ? void 0 : item[key];
  });
};
export default mapNestedKey;